"use strict";

var _slicedToArray = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _classCallCheck = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMappingRef = exports.isAbsoluteUrl = exports.refBaseName = exports.pointerBaseName = exports.parsePointer = exports.parseRef = exports.escapePointer = exports.unescapePointer = exports.Location = exports.isRef = exports.joinPointer = void 0;

var utils_1 = require("./utils");

function joinPointer(base, key) {
  if (base === '') base = '#/';
  return base[base.length - 1] === '/' ? base + key : base + '/' + key;
}

exports.joinPointer = joinPointer;

function isRef(node) {
  return node && typeof node.$ref === 'string';
}

exports.isRef = isRef;

var Location = /*#__PURE__*/function () {
  function Location(source, pointer) {
    _classCallCheck(this, Location);

    this.source = source;
    this.pointer = pointer;
  }

  _createClass(Location, [{
    key: "child",
    value: function child(components) {
      return new Location(this.source, joinPointer(this.pointer, (Array.isArray(components) ? components : [components]).map(escapePointer).join('/')));
    }
  }, {
    key: "key",
    value: function key() {
      return Object.assign(Object.assign({}, this), {
        reportOnKey: true
      });
    }
  }, {
    key: "absolutePointer",
    get: function get() {
      return this.source.absoluteRef + (this.pointer === '#/' ? '' : this.pointer);
    }
  }]);

  return Location;
}();

exports.Location = Location;

function unescapePointer(fragment) {
  return decodeURIComponent(fragment.replace(/~1/g, '/').replace(/~0/g, '~'));
}

exports.unescapePointer = unescapePointer;

function escapePointer(fragment) {
  if (typeof fragment === 'number') return fragment;
  return fragment.replace(/~/g, '~0').replace(/\//g, '~1');
}

exports.escapePointer = escapePointer;

function parseRef(ref) {
  var _ref$split = ref.split('#/'),
      _ref$split2 = _slicedToArray(_ref$split, 2),
      uri = _ref$split2[0],
      pointer = _ref$split2[1];

  return {
    uri: uri || null,
    pointer: pointer ? pointer.split('/').map(unescapePointer).filter(utils_1.isTruthy) : []
  };
}

exports.parseRef = parseRef;

function parsePointer(pointer) {
  return pointer.substr(2).split('/').map(unescapePointer);
}

exports.parsePointer = parsePointer;

function pointerBaseName(pointer) {
  var parts = pointer.split('/');
  return parts[parts.length - 1];
}

exports.pointerBaseName = pointerBaseName;

function refBaseName(ref) {
  var parts = ref.split(/[\/\\]/); // split by '\' and '/'

  return parts[parts.length - 1].replace(/\.[^.]+$/, ''); // replace extension with empty string
}

exports.refBaseName = refBaseName;

function isAbsoluteUrl(ref) {
  return ref.startsWith('http://') || ref.startsWith('https://');
}

exports.isAbsoluteUrl = isAbsoluteUrl;

function isMappingRef(mapping) {
  // TODO: proper detection of mapping refs
  return mapping.startsWith('#') || mapping.startsWith('https://') || mapping.startsWith('http://') || mapping.startsWith('./') || mapping.startsWith('../') || mapping.indexOf('/') > -1;
}

exports.isMappingRef = isMappingRef;